__turbopack_context__.v({
  "className": "permanent_marker_893e2021-module__CLKRZG__className",
});
